export function marquee() {
  const marqueeElementsDt = document.querySelectorAll("[data-marquee-dt]");
  const marqueeElementsMob = document.querySelectorAll("[data-marquee-mob]");

  if (marqueeElementsDt.length !== 0) {
    marqueeElementsDt.forEach((el) => animateMarquee(el, 30000));
  }

  if (marqueeElementsMob.length !== 0) {
    marqueeElementsMob.forEach((el) => animateMarquee(el, 30000));
  }
}

function animateMarquee(el, duration) {
  const innerEl = el.querySelector(".marquee__inner");
  const innerWidth = innerEl.offsetWidth;
  const cloneEl = innerEl.cloneNode(true);
  el.appendChild(cloneEl);

  let start = performance.now();
  let progress;
  let translateX;

  requestAnimationFrame(function step(now) {
    progress = (now - start) / duration;

    if (progress > 1) {
      progress %= 1;
      start = now;
    }

    translateX = innerWidth * progress;

    innerEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
    cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
    requestAnimationFrame(step);
  });
}